export const salutations = ['mr', 'ms', 'non-binary'] as const

export type Salutation = (typeof salutations)[number]

export const isValidSalutation = (salutation: string): salutation is Salutation =>
  salutations.some((item) => item === salutation)

export const languages = ['en', 'de', 'zh', 'es', 'pl'] as const

export type Language = (typeof languages)[number]

export const isValidLanguage = (language: string): language is Language => languages.some((item) => item === language)

export type User = {
  _id: string
  salutation?: Salutation
  title?: string
  firstName: string
  lastName: string
  email: string
  phoneMobile?: string
  phoneLandline?: string
  customer_id: string
  isBilling?: boolean
  roles: string[]
  languages?: Language[]
  organizationId: string
  preferredLanguage?: Language
}
